import React from 'react';
import cx from 'classnames';
import classes from './styles.module.scss';

const Text: React.FC<{ className: string }> = ({ children, className }) => {
    return <p className={cx(classes.text, className)}>{children}</p>;
};

export default Text;
